export const DEFAULT_COUNTRY = { name: 'España', callingCode: '34', cca2: 'ES' }
export const MESSAGES_TYPES = { TEXT: 'TEXT', AUDIO: 'AUDIO', IMAGE: 'IMAGE', FILE: 'FILE', POLL: 'POLL', TEMP: 'TEMP' }
export const SUBSCRIPTION_STATUS = { ACTIVE: 'active', PENDING: 'pending' }
export const appleStoreUrl = 'https://apps.apple.com/es/app/beenfo/id1495054205'
export const googlePlayUrl = 'https://play.google.com/store/apps/details?id=com.beenfo_app&gl=ES'

export const TOO_MANY_ATTEMTPS_ERROR = 'auth/too-many-requests'
export const INVALID_CODE_ERROR = 'auth/invalid-verification-code'
